export function Logo({ size = 40, showText = true }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="caden-logo">
      <div
        className="brand-gradient flex items-center justify-center font-heading font-black text-white shrink-0"
        style={{ width: size, height: size, borderRadius: size * 0.28, fontSize: size * 0.6 }}
      >
        C
      </div>
      {showText && (
        <div className="leading-none">
          <span className="font-heading font-black tracking-tight text-foreground" style={{ fontSize: size * 0.55 }}>
            Caden
          </span>
          <span className="font-heading font-black tracking-tight text-brand-gradient" style={{ fontSize: size * 0.55 }}>
            .coach
          </span>
        </div>
      )}
    </div>
  );
}
